import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    // Optional: console.log to verify controller loaded
    // console.log("DisableSubmitController connected")
  }

  disable(event) {
    const clickedButton = event.currentTarget

    // Prevent double-click
    if (clickedButton.disabled) return

    // Grab the confirmation message from data-confirm attribute
    const confirmMessage = clickedButton.dataset.confirm
    if (confirmMessage && !window.confirm(confirmMessage)) {
      // User clicked Cancel
      event.preventDefault()
      return
    }

    // Disable all buttons in this controller
    this.buttonTargets.forEach(btn => btn.disabled = true)

    // Show spinner + update text for clicked button
    const spinner = clickedButton.querySelector(".spinner-border")
    const text = clickedButton.querySelector(".button-text")
    if (spinner) spinner.classList.remove("d-none")
    if (text) text.textContent = "Changing..."

    // Submit form
    clickedButton.form.submit()
  }
}